import { sanitizeRichTextHtml } from "@sd/lib/richTextUtils";

function looksLikeHtml(value: string): boolean {
  return /<[a-z][\s\S]*>/i.test(value);
}

const htmlContentClass =
  "break-words text-sm leading-relaxed [&_p]:mb-3 [&_p:last-child]:mb-0 [&_ul]:my-2 [&_ul]:list-disc [&_ul]:pl-5 [&_ol]:my-2 [&_ol]:list-decimal [&_ol]:pl-5 [&_blockquote]:my-2 [&_blockquote]:border-l-[3px] [&_blockquote]:border-slate-300 [&_blockquote]:pl-3 [&_blockquote]:text-muted-foreground [&_h1]:text-xl [&_h1]:font-bold [&_h2]:text-lg [&_h2]:font-bold [&_strong]:font-bold [&_b]:font-bold [&_em]:italic [&_i]:italic [&_u]:underline [&_.ql-size-small]:text-[0.75em] [&_.ql-size-large]:text-[1.5em] [&_.ql-size-huge]:text-[2.5em] [&_.ql-font-serif]:font-serif [&_.ql-font-monospace]:font-mono [&_a]:text-primary [&_a]:underline";

export function TicketDescriptionContent({
  description,
  className = "",
}: {
  description: string;
  className?: string;
}) {
  const trimmed = description.trim();
  if (!trimmed) return null;

  if (looksLikeHtml(trimmed)) {
    return (
      <div
        className={`${htmlContentClass} ${className}`.trim()}
        dangerouslySetInnerHTML={{
          __html: sanitizeRichTextHtml(trimmed),
        }}
      />
    );
  }

  return (
    <p className={`whitespace-pre-wrap break-words ${className}`.trim()}>
      {trimmed}
    </p>
  );
}
